import crypto from 'crypto';
import { fg } from '@atlaskit/platform-feature-flags';
import { navigateToTeamsApp } from '@atlaskit/teams-app-config/navigation';

/**
 * Strip highlight markers from text
 */
export var cleanExcerpt = function cleanExcerpt(text) {
  return text && text.replace(/@@@hl@@@/g, '').replace(/@@@endhl@@@/g, '');
};

// copied over from @confluence/hash
var hash = function hash(algorithm, data) {
  var asBytes = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var hash = crypto.createHash(algorithm);
  hash.update(data);
  if (asBytes) {
    return Array.from(hash.digest());
  }
  return hash.digest('hex');
};
export var hashDataAsByte = function hashDataAsByte(data) {
  return hash('sha256', data, true);
};
export var hashData = function hashData(data) {
  return hash('sha256', data);
};

// TODO: Remove this once each product passes this value via the generateUserUrl prop
export var getUserPath = function getUserPath(userId, primaryProduct, orgId, cloudId) {
  if (primaryProduct === 'confluence') {
    return fg('platform-adopt-teams-nav-config') ? navigateToTeamsApp({
      type: 'USER',
      payload: {
        userId: userId
      },
      cloudId: cloudId,
      hostProduct: 'confluence'
    }).href : "/wiki/people/".concat(userId);
  } else if (primaryProduct === 'townsquare') {
    return fg('platform-adopt-teams-nav-config') ? navigateToTeamsApp({
      type: 'USER',
      payload: {
        userId: userId
      },
      cloudId: cloudId,
      hostProduct: 'home'
    }).href : "/o/".concat(orgId, "/people/").concat(userId, "?cloudId=").concat(cloudId);
  }
};

// TODO: Remove this once each product passes this value via the generateTeamUrl prop
export var getTeamPath = function getTeamPath(teamId, primaryProduct, orgId, cloudId) {
  if (primaryProduct === 'confluence') {
    return fg('platform-adopt-teams-nav-config') ? navigateToTeamsApp({
      type: 'TEAM',
      payload: {
        teamId: teamId
      },
      cloudId: cloudId,
      hostProduct: 'confluence'
    }).href : "/wiki/people/team/".concat(teamId);
  } else if (primaryProduct === 'townsquare') {
    return fg('platform-adopt-teams-nav-config') ? navigateToTeamsApp({
      type: 'TEAM',
      payload: {
        teamId: teamId
      },
      cloudId: cloudId
    }).href : "/o/".concat(orgId, "/people/team/").concat(teamId, "?cloudId=").concat(cloudId);
  }
};